export default __webpack_public_path__ + "static/voting-funds-flat-e729bf1af53cf0a40bd12276d3b20926.svg";